import { apiFetch } from "./client";
import type { ContentsResponse } from "./types";

/**
 * Fetch a folder's contents. At root (folderId === null) the query param is
 * OMITTED entirely — the server rejects literal `root`/empty on this endpoint.
 */
export function getContents(folderId: string | null): Promise<ContentsResponse> {
  const path =
    folderId === null
      ? "/api/contents"
      : `/api/contents?folderId=${encodeURIComponent(folderId)}`;
  return apiFetch<ContentsResponse>(path);
}
